import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

const SPAM_TRIGGER_WORDS = [
  // Urgency / pressure
  "urgent",
  "act now",
  "limited time",
  "don't miss",
  "last chance",
  "expires",
  "hurry",
  "immediately",
  "instant",
  "now only",
  "one time only",
  "while supplies last",
  // Money / free
  "free",
  "buy now",
  "order now",
  "no cost",
  "no obligation",
  "risk free",
  "no fees",
  "best price",
  "cheap",
  "lowest price",
  "bargain",
  "discount",
  "save big",
  "double your",
  // Winner / prize
  "winner",
  "congratulations",
  "you have been selected",
  "you've been selected",
  "claim your",
  "prize",
  // Trust / credibility
  "guaranteed",
  "no strings attached",
  "100%",
  "promise",
  // Action / CTA
  "click here",
  "click below",
  "sign up free",
  "subscribe now",
  "apply now",
  "call now",
  // Financial
  "earn money",
  "make money",
  "cash bonus",
  "million dollars",
  "investment",
  "credit card",
  "as seen on",
  // Misc
  "dear friend",
  "this is not spam",
  "unsubscribe",
];

const pluginKey = new PluginKey("spamHighlight");

function findSpamWords(doc) {
  const decorations = [];

  doc.descendants((node, pos) => {
    if (!node.isText) return;
    const text = node.text.toLowerCase();

    for (const word of SPAM_TRIGGER_WORDS) {
      let idx = 0;
      while ((idx = text.indexOf(word, idx)) !== -1) {
        // Only match whole words or phrases (not partial matches within words)
        const before = idx > 0 ? text[idx - 1] : " ";
        const after =
          idx + word.length < text.length ? text[idx + word.length] : " ";
        const boundaryRe = /[\s.,;:!?'"()\-–—/\[\]{}]/;
        if (boundaryRe.test(before) && boundaryRe.test(after)) {
          decorations.push(
            Decoration.inline(pos + idx, pos + idx + word.length, {
              class: "spam-highlight",
              title: `"${word}" is a common spam trigger word`,
            }),
          );
        }
        idx += word.length;
      }
    }
  });

  return DecorationSet.create(doc, decorations);
}

export const SpamHighlight = Extension.create({
  name: "spamHighlight",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: pluginKey,
        state: {
          init(_, { doc }) {
            return findSpamWords(doc);
          },
          apply(tr, oldSet) {
            if (tr.docChanged) {
              return findSpamWords(tr.doc);
            }
            return oldSet;
          },
        },
        props: {
          decorations(state) {
            return this.getState(state);
          },
        },
      }),
    ];
  },
});

export { SPAM_TRIGGER_WORDS };
